import formatMoney from '../../utils/formatMoney'
import { Pill } from '../../common/RefundPill'
import { pendingTotals, positiveBalances } from './wallet'

function BalanceAmount({ item }) {
  return (
    <div className='flex flex-col'>
      <span
        data-testid={`wallet-balance-${item.currency}`}
        className='text-[1.75rem] leading-tight font-bold tabular-nums tracking-tight text-espresso dark:text-white'
      >
        {formatMoney(item.balance, item.currency)}
      </span>
      {item.held > 0 && (
        <span
          data-testid={`wallet-split-${item.currency}`}
          className='text-xs font-semibold tabular-nums text-warm_gray dark:text-gray-400'
        >
          Disponible {formatMoney(item.available, item.currency)} · Reservado{' '}
          {formatMoney(item.held, item.currency)}
        </span>
      )}
    </div>
  )
}

export default function WalletBalanceCard({ wallet }) {
  const balances = positiveBalances(wallet)
  const pending = pendingTotals(wallet)

  return (
    <section
      aria-label='Saldo Viatik'
      className='rounded-2xl bg-cream dark:bg-dk-raised ring-1 ring-warm_border dark:ring-dk-border px-5 py-4 text-left'
    >
      <div className='flex flex-wrap items-center justify-between gap-2'>
        <span className='text-[11px] uppercase tracking-wider font-medium text-warm_gray dark:text-gray-400'>
          Saldo Viatik
        </span>
        <div className='flex flex-wrap items-center gap-1.5'>
          {wallet?.frozen && <Pill tone='alert'>Congelado</Pill>}
          {wallet && !wallet.enabled && <Pill tone='neutral'>Reembolso a saldo apagado</Pill>}
          {wallet?.canPay === false && <Pill tone='neutral'>Pago con saldo apagado</Pill>}
        </div>
      </div>
      {balances.length > 0 ? (
        <div className='mt-1 flex flex-wrap items-start gap-x-6 gap-y-1'>
          {balances.map(item => (
            <BalanceAmount key={item.currency} item={item} />
          ))}
        </div>
      ) : (
        <p className='mt-1 text-lg font-semibold text-warm_gray dark:text-gray-400'>Sin saldo</p>
      )}
      {pending.length > 0 && (
        <p className='mt-2 text-xs font-semibold tabular-nums text-amber-700 dark:text-amber-400'>
          En proceso: {pending.map(item => formatMoney(item.amount, item.currency)).join(' · ')}
        </p>
      )}
    </section>
  )
}
